import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFamilyStore } from '@/store/familyStore';
import { PersonalInfoForm, InvalidLink, SubmissionSuccess, SharedLayout } from '../components';
import { useSharedLink } from '../hooks/useSharedLink';
import { generateId } from '@/utils/generators';

export function SharedInfo() {
  const { token } = useParams();
  const { addPersonalInfoRequest } = useFamilyStore();
  const { link, error, isValid } = useSharedLink(token, 'info');
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const [formData, setFormData] = useState({
    fullName: '',
    description: '',
    photoUrl: '',
    resumeUrl: '',
    isResumePublic: false,
    forSelf: true,
  });

  if (!isValid || !link?.targetId) {
    return <InvalidLink message={error || 'رابط غير صالح'} />;
  }

  if (isSubmitted) {
    return <SubmissionSuccess type="info" />;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const request = {
      id: generateId(),
      requesterId: link.targetId,
      requesterName: formData.fullName,
      phoneNumber: '', // Will be filled by admin
      status: 'pending' as const,
      timestamp: Date.now(),
      personalInfo: {
        ...formData,
      },
    };
    
    addPersonalInfoRequest(request);
    setIsSubmitted(true);
  };

  return (
    <SharedLayout title="إضافة من أنت">
      <PersonalInfoForm
        formData={formData}
        onChange={setFormData}
        onSubmit={handleSubmit}
      />
    </SharedLayout>
  );
}